import PropTypes from 'prop-types';

// There are places that use the whole report state as a prop so here we provide convenience and prevent having to
// copy it all over the place. Changes can be made just here.
export default {
    dateFrom: PropTypes.string,
    dateTo: PropTypes.string,
    gameTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isAggregate: PropTypes.bool,
    isDateRangeFromSeasons: PropTypes.bool,
    franchiseId: PropTypes.string,
    positionCode: PropTypes.string,
    reportName: PropTypes.string,
    seasonFrom: PropTypes.number,
    seasonTo: PropTypes.number,
    timeFrame: PropTypes.string,
};
